import PropTypes from 'prop-types'


const Button = ({href, text, className = '', isImage, imgSrc, handleClick}) => {
    if(!isImage){
        return (
            <a className={`nav-item nav-link ${className}`} href={`#${href}`} id={`section-${href}`} onClick={handleClick(this)}>{text}</a>
        );
    }
    else{
        return (
            <a className={`nav-item nav-link ${className}`} href={`#${href}`} id={`section-logo-${href}`} onClick={handleClick(document.getElementById("section-home"))}>
                <img className="img-logo img-responsive img-change-logo" src={imgSrc} alt="logo"/>
            </a>
        );
    }
}


Button.defaultProps = {
    text : 'No Name'
}

Button.propTypes = {
    text: PropTypes.string
}

export default Button
